import type { ReactNode } from "react"

const CITY_COUNT = 6
const cityIndex = Math.floor(Math.random() * CITY_COUNT)

export function AuthLayout({ children }: { children: ReactNode }) {
  return (
    <div className="relative flex min-h-screen items-center justify-center">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url(/static/cities/city${cityIndex}.webp)`,
        }}
      />
      <div className="absolute inset-0 backdrop-blur-sm bg-[rgba(22,20,52,0.72)]" />
      <div className="relative z-10 w-full max-w-md px-4 flex flex-col items-center gap-6">
        <img src="/static/kaptcher-logo-full.png" alt="Kaptcher" className="h-12 brightness-0 invert" />
        {children}
      </div>
    </div>
  )
}
